module.exports = __webpack_public_path__ + "img/alone.456547e1.svg";